import { Card, Row } from 'antd';

import { Block, CheckInInline, EmployeeStatistic } from '@/components';
import { TIMETRACKER_SCHEMA_LABEL } from '@/configs/entities';
import { COLOR } from '@/configs/general';
import { timetracker } from '@/models';

const COL_PROPS = { span: 6 };

const GeneralInfo = (props) => {
  const { employeeInfo, loading, user } = props;
  const { timeTrackerUser } = user || {};

  const isHourlyPaidEmployee = timetracker.isHourlyPaidEmployee(timeTrackerUser);
  const checkedIn = timetracker.checkCheckedIn(timeTrackerUser?.activeCheckInTimestamp);
  const isOvernight = timetracker.checkOvernight(timeTrackerUser?.activeCheckInTimestamp);

  return (
    <Block>
      <Card title="Time tracking info">
        <Row>
          {!isOvernight && (
            <EmployeeStatistic
              title="Current status"
              value={checkedIn ? 'Working' : 'Away'}
              color={checkedIn ? COLOR.GREEN : COLOR.GOLD}
              loading={loading}
              colProps={COL_PROPS}
            />
          )}
          {isOvernight && (
            <EmployeeStatistic
              title="Current status"
              value="Overnight"
              color={COLOR.RED}
              loading={loading}
              colProps={COL_PROPS}
            />
          )}
          {!isOvernight && employeeInfo?.checkedInAt && (
            <EmployeeStatistic
              title="Last check-in"
              value={<CheckInInline value={employeeInfo.checkedInAt} />}
              loading={loading}
              colProps={COL_PROPS}
            />
          )}
          <EmployeeStatistic
            title="Workday info"
            value={
              !employeeInfo?.isRegularDay || !employeeInfo?.schema
                ? "Work isn't scheduled"
                : `${timetracker.durationToText(employeeInfo.ratedMinutes)} worked${
                    employeeInfo.flexTime < 0 ? `, ${timetracker.durationToText(-employeeInfo.flexTime)} left` : ''
                  }`
            }
            loading={loading}
            colProps={COL_PROPS}
          />
          <EmployeeStatistic
            title="Schema"
            value={TIMETRACKER_SCHEMA_LABEL[String(user?.country)]?.[String(timeTrackerUser?.schema)]}
            color={timeTrackerUser?.schema < 100 ? COLOR.RED : null}
            showHourlyPaidTag={isHourlyPaidEmployee}
            loading={loading}
            colProps={COL_PROPS}
          />
        </Row>
      </Card>
    </Block>
  );
};

export { GeneralInfo };
